import styled from 'styled-components';

/**
 * POSCard - A themed card component for POS interfaces
 * Supports dark theme with glass-morphism effect
 */
export const POSCard = styled.div`
  background: ${(props) =>
    props.theme.name === 'dark'
      ? props.theme.colors?.card?.background || 'rgba(255, 255, 255, 0.05)'
      : '#ffffff'};
  border: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors?.card?.border || 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  border-radius: ${(props) => props.theme.borderRadius?.lg || '12px'};
  overflow: hidden;
  box-sizing: border-box;
`;

/**
 * POSCardHeader - Header section for POS cards
 */
export const POSCardHeader = styled.div`
  padding: 20px 24px;
  border-bottom: 1px solid
    ${(props) =>
      props.theme.name === 'dark'
        ? props.theme.colors?.border || 'rgba(255, 255, 255, 0.1)'
        : 'rgba(0, 0, 0, 0.1)'};
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
`;

/**
 * POSCardBody - Body section for POS cards
 */
export const POSCardBody = styled.div`
  padding: ${(props) => (props.noPadding ? '0' : '24px')};
  flex: 1 1 0;
  min-height: 0;
  overflow: hidden;

  @media (max-width: 1024px) {
    flex: 1 1 auto;
    min-height: 300px;
  }
`;

export default POSCard;
